import {edinet} from "@/edinet/libs/ix_mappings";
import {SmartTableBlock} from "@/edinet/libs/smarttable";
import {s} from "@/edinet/libs/utils";
import {EdinetDocIndexCli} from "@/edinet/store_edinet";
import {DocType, LargeHoldingMeta, Meta, Period, XbrlContextMap, XbrlMeta} from "@/edinet/types";
import $ from "jquery";
import Vue from "vue";

//define interface for calling child component's method
export interface VueUpdatable extends Vue {
    update: () => void
}

export interface VueAnnotatableDiv extends Vue {
    loadAnnotations: (docId: string) => void
    setupAnnotations: () => void
}

function setupSmartTable(names: string[], sym: string, found: string[], contextMap: XbrlContextMap, salesIxNames?: string[]) {
    const selector = names.map(x => s(`ix:nonnumeric[name=${x}]`)).join(',')
    $(selector).each((i, x) => {
        const name = $(x).attr('name')
        if (name) {
            found.push(name)
            const exploreUrl = `/edinet/explorer?sym=${sym}&tag=ix:nonnumeric&names=${names.join(',')}&renderer=div-table`
            const block = new SmartTableBlock(x, contextMap, exploreUrl, salesIxNames)
            block.setup()
        }
    })
}

export function setupSmartTables(sym: string, contextMap: XbrlContextMap) {
    const found = [] as string[]

    //consolidated
    setupSmartTable(edinet.financials.consolidated.bs, sym, found, contextMap)
    setupSmartTable(edinet.financials.consolidated.in, sym, found, contextMap, ['jppfs_cor:NetSales'])
    setupSmartTable(edinet.financials.consolidated.cf, sym, found, contextMap)
    // //non-consolidated
    setupSmartTable(edinet.financials.nonconsolidated.bs, sym, found, contextMap)
    setupSmartTable(edinet.financials.nonconsolidated.in, sym, found, contextMap, ['jppfs_cor:NetSales'])
    setupSmartTable(edinet.financials.nonconsolidated.cf, sym, found, contextMap)

    // console.log(`setting up smarttable for ${found.length} blocks %o...`, found)
    $('table:has(ix\\:nonfraction)').each((_, table) => {
        const parent = table.parentElement
        if (parent) {
            const block = new SmartTableBlock(parent, contextMap, undefined)
            block.setup()
        } else {
            console.warn('unable to setup smarttable because table %o has no parent', table)
        }
    })
}

export function getTitle(meta: Meta): string {
    if (meta.docType === DocType.Financials) {
        const xbrlMeta = (meta as XbrlMeta)
        return `${xbrlMeta.year}${Period[xbrlMeta.period]} ${xbrlMeta.sym}`
    } else if (meta.docType === DocType.LargeHoldingChange) {
        return meta.sym + ': ' + (meta as LargeHoldingMeta).submitterName
    } else {
        return meta.sym
    }
}

export function filterEdinetDocIndexByDocType(docIndices: EdinetDocIndexCli[], filterDocType: string): EdinetDocIndexCli[] {
    if (filterDocType === 'Relevant') {
        return docIndices.filter(x => x.guessDocType !== 'Others')
    } else if (filterDocType === 'All') {
        return docIndices
    } else {
        return docIndices.filter(x => x.guessDocType === filterDocType)
    }
}